import httpClient from './httpClient';

const BASE_URL = '/emails';

export interface EmailTemplateDto {
  id?: number;
  code?: string;
  name: string;
  description?: string | null;
  subjectTemplate: string;
  bodyHtmlTemplate: string;
  defaultTo?: string[];
  defaultCc?: string[];
  defaultBcc?: string[];
  active?: boolean;
}

export interface EmailServerConfigDto {
  id?: number;
  name?: string;
  host?: string;
  port?: number;
  username?: string | null;
  password?: string | null;
  secure?: boolean;
  defaultFromName?: string | null;
  defaultFromEmail?: string | null;
  active?: boolean;
}

export interface PaginatedEmailTemplatesResponse {
  results: EmailTemplateDto[];
  total: number;
}

export const getEmailTemplates = async (
  params?: {
    limit?: number;
    offset?: number;
    search?: string;
    sort?: string;
    order?: string;
  }
): Promise<PaginatedEmailTemplatesResponse> => {
  const { data } = await httpClient.get(`${BASE_URL}`, { params });
  return data;
};

export const getEmailTemplate = async (id: number): Promise<EmailTemplateDto> => {
  const { data } = await httpClient.get(`${BASE_URL}/${id}`);
  return data;
};

export const createEmailTemplate = async (
  payload: EmailTemplateDto,
): Promise<EmailTemplateDto> => {
  const { data } = await httpClient.post(`${BASE_URL}`, payload);
  return data;
};

export const updateEmailTemplate = async (
  id: number,
  payload: Partial<EmailTemplateDto>,
): Promise<EmailTemplateDto> => {
  const { data } = await httpClient.patch(`${BASE_URL}/${id}`, payload);
  return data;
};

export const deleteEmailTemplate = async (id: number): Promise<void> => {
  await httpClient.delete(`${BASE_URL}/${id}`);
};

export const getEmailServerConfig = async (): Promise<EmailServerConfigDto | null> => {
  const { data } = await httpClient.get(`${BASE_URL}/server/config`);
  return data;
};

export const updateEmailServerConfig = async (
  payload: EmailServerConfigDto,
): Promise<EmailServerConfigDto> => {
  const { data } = await httpClient.patch(`${BASE_URL}/server/config`, payload);
  return data;
};

export const sendTestEmail = async (to: string) => {
  const { data } = await httpClient.post(`${BASE_URL}/server/test`, { to });
  return data;
};

export const verifySMTPConnection = async (tempConfig?: EmailServerConfigDto) => {
  const { data } = await httpClient.post(`${BASE_URL}/server/verify`, tempConfig || {});
  return data;
};

export const getAllEmailServers = async (): Promise<EmailServerConfigDto[]> => {
  const { data } = await httpClient.get(`${BASE_URL}/server/all`);
  return data;
};

export const setActiveEmailServer = async (id: number): Promise<EmailServerConfigDto> => {
  const { data } = await httpClient.post(`${BASE_URL}/server/${id}/activate`);
  return data;
};

export const deleteEmailServer = async (id: number): Promise<void> => {
  await httpClient.delete(`${BASE_URL}/server/${id}`);
};



